import getPlaybookCardData from './getPlaybookCardData';

export default function getPlaybooksHighlightData(props) {
  const {
    playbooksHighlightTitle,
    playbooksHighlightDescription,
    playbooksHighlightPlaybooks,
    playbooksHighlightButtonLabel,
  } = props;

  const data = {};

  data.title = playbooksHighlightTitle || false;
  data.description = playbooksHighlightDescription || false;
  const cardList = playbooksHighlightPlaybooks ? [] : false;

  if (cardList) {
    playbooksHighlightPlaybooks.map((entry) => {
      const item = getPlaybookCardData(entry);
      cardList.push(item);
      return true;
    });
  }

  data.list = cardList || false;

  if (playbooksHighlightButtonLabel) {
    data.button = {};
    data.button.label = playbooksHighlightButtonLabel;
    data.button.modifier = 'Button--deepPurple';
    data.button.url = '/playbooks';
  }

  return Object.keys(data).length ? data : false;
}
